import $ from "jquery";

export default class rest {
  constructor(parent) {
    this.url = parent.param.server;
    this.token = null;
    this.parent = parent;
    this.xhr = null;
  }

  post(action, data, complete, cancelPrevisouRequest = true) {
    this.call(
      action,
      "POST",
      data,
      function (msg) {
        complete(msg);
      },
      cancelPrevisouRequest
    );
  }
  get(action, complete, cancelPrevisouRequest = true) {
    this.call(
      action,
      "GET",
      null,
      function (msg) {
        complete(msg);
      },
      cancelPrevisouRequest
    );
  }
  delete(action, data, complete) {
    this.call(action, "DELETE", data, function (msg) {
      complete(msg);
    });
  }

  call(action, method, data, complete, cancelPrevisouRequest) {
    var auth = this.getAuth();
    var self = this;
    if (this.xhr != null && cancelPrevisouRequest == true) {
      this.xhr.abort();
    }
    // if (action !== 'trns?language=cs_CZ') {
    //   action = action + '?XDEBUG_SESSION_START=1';
    // }
    this.xhr = $.ajax({
      method: method,
      contentType: "application/json",
      url: self.url + "/" + action,
      // url: self.url + "/" + action+"?XDEBUG_SESSION_START=1",

      data: JSON.stringify(data),
      headers: auth,
      success: (data) => {
        //zobrazeni fatalnejsich chyb, ktere mohou prerusit routovani atd.
        if (typeof data === "object" && data.status === "error") {
          if (data.reason != undefined) {
            self.parent.dsClear();
            if (self.parent.dataGet("rightPanel/show") == true) {
              self.parent.dsAdd("set", "rightPanel/content", "error");
              self.parent.dsAdd("set", "conf/load", false);
              self.parent.dsAdd("set", "rightPanel/data", {
                state: false,
                type: data.reason,
              });
            } else {
              self.parent.dsAdd("set", "conf/view", "error");
              self.parent.dsAdd("set", "conf/load", false);
              self.parent.dsAdd("set", "view", {
                state: false,
                type: data.reason,
              });
            }

            self.parent.dsProcess();
          } else {
            self.parent.unLoad();
            self.parent.error(self.parent.translate(data.msg || data.message));
          }
        }

        complete(data);

        //zobrazeni dalsich chybovych hlasek
        if (typeof data === "object" && data.status === "warning") {
          setTimeout(function () {
            self.parent.error(self.parent.translate(data.msg || data.message));
          }, 2500);
        }
      },
      error: (XMLHttpRequest, textStatus, errorThrown) => {
        if (
          (XMLHttpRequest.status == "401" || XMLHttpRequest.status == 0) &&
          XMLHttpRequest.statusText != "abort"
        ) {
          if(action === "getNotifyCount" || action === "recalcTopRecent"){
            return;
          }
          
          if (!window.location.hash.startsWith('#login')) {
            if (XMLHttpRequest.status == "401") {

              window.location.hash = "#login";

              this.get("trns", data => {
                self.parent.app_strings = data.lang;
                self.parent.renderReact();
              });
            } else {
              self.parent.error(self.parent.translate("LBL_SERVER_ERROR"));
              self.parent.unLoad();
            }
          } else {
            clearInterval(this.parent.notificationInterval);
            self.parent.routeLogin();
          }
        }
      },
    });
  }
  getAuth() {
    var token = this.getCookie("sID");
    var auth = {
      sID: token,
    };

    if (this.parent.deviceType != undefined) {
      auth["device"] = this.parent.deviceType;
    }

    return auth;
  }
  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  }
  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return null;
  }
    /**
     * Metoda pocita s formatem dat v coripo standardu, jinak nebude fungovat spravne.
     * @param {string} action xxx
     * @param {string} method xxx
     * @param {null|any} data xxx
     * @param {boolean} cancelPreviousRequest xxx
     * @returns {Promise<any>} xxx
     */
    async fetchData(action, method, data = null, cancelPreviousRequest = true) {
        const self = this;
        const sId = this.getAuth();
        let url = self.url + '/' + action;
        if (this.parent?.param?.xdebugEnabled) {
            url += (url?.includes('?') ? '&' : '?') + 'XDEBUG_SESSION_START=1';
        }

        if (this.controller && cancelPreviousRequest) {
            console.warn('Canceling previous request fetch by ', action);
            this.controller.abort();
        }

        this.controller = new AbortController();

        const fetchParams = {
            method: method,
            contentType: 'application/json',
            signal: this.controller.signal,
            headers: new Headers({
                'content-type': 'application/json',
                'sId': sId.sID,
                'device': self.parent.deviceType,
            }),
        };

        if (['POST', 'PUT', 'PATCH'].includes(method) && data) {
            fetchParams.body = JSON.stringify(data);
        } else if (data && typeof data === 'object') {
            // encode data to url query string for methods that don't support body
            // immutable Map used so object can be treated as associative array
            url += (url?.includes('?') ? '&' : '?') + (new Map(data)).map((value, param) => {
                // if value is array, add multiple params with same name and [] at the end
                if (Array.isArray(value)) {
                    return value.map((value) => {
                        return encodeURIComponent(param) + '[]=' + encodeURIComponent(value);
                    }).join('&');
                }

                return encodeURIComponent(param) + '=' + encodeURIComponent(value);
            }).join('&');
        } else if (data) {
            console.error(`Unsupported data of type ${typeof data} for method ${method}`);
        }

        const fetchedData = await fetch(url, fetchParams).then((response) => response.json()).then((result) => {
            return result;
        }).catch((responseError) => {
            switch (responseError.name) {
                case 'AbortError':
                    console.warn(`Request ${action} canceled`);
                    return {status: false, errorMessage: {FE_ABORT: true}};
                default:
                    this.parent.unLoad();
                    console.error('Error', responseError);
                    console.warn('You propably have error in your BE method returned data is not valid JSON');
            }
        });

        if (!fetchedData?.status) {
            throw fetchedData?.errorMessage
            // old api compatibility
            || fetchedData;
        }

        return fetchedData.message;
    }
}
